module.exports = __webpack_public_path__ + "img/warning.8a1f7c44.svg";